// extracted by mini-css-extract-plugin
export default {"jl_titre_album":"liste-album_jl_titre_album__7Ghb8"};